module.exports = __webpack_public_path__ + "img/delete.d9be4ddb.svg";